// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3Asq4","header":"ReportDetails_header__1zI82","title":"ReportDetails_title__KNwSO","left":"ReportDetails_left__2wjT6"};